import React from 'react';
import {useAuth} from "context/AuthContext";
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {useNavigate} from "react-router-dom";
import {EventType} from "types/EventType";

// Types ----

type EventTypeContextMenuProps = {
  eventType: EventType
  onDeleteEventType: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
};

// Component ----

function EventTypeContextMenu({eventType, onDeleteEventType, editDisabled, deleteDisabled, position = 'right'}: EventTypeContextMenuProps) {
  const auth = useAuth();
  const navigate = useNavigate();

  function editEventType() {
    void navigate(`/event-types/${eventType.id}/edit`)
  }

  return (
    <Dropdown hideIfEmpty position={position}>
      {auth.can('event-types:write') &&
        <DropdownItem name={'Edit'} icon={PencilIcon} onClick={editEventType} disabled={!!editDisabled}/>
      }

      {auth.can('event-types:write') &&
        <DropdownItem name={'Delete'} icon={TrashIcon} onClick={onDeleteEventType} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default EventTypeContextMenu;